import axios from "axios";
import store from "@/store";
import { ElMessage, ElLoading, ElMessageBox } from "element-plus";
import router from "@/router";

// 创建axios实例
let request = axios.create({
  //配置接口ip前缀
  baseURL: localStorage["host"] || "/", // api的base_url根路径，填你自己项目的根路径
  timeout: 5000, // 请求超时时间
  // 自定义后端返回的原始数据
  // data: 后端返回的原始数据，说白了就是 JSON 格式的字符串
  transformResponse: [
    function (data) {
      try {
        data = JSON.parse(data);
        return data;
      } catch (err) {
        return data;
      }
    },
  ],
});
// 请求拦截器
// Add a request interceptor
request.interceptors.request.use(
  function (config) {
    // 设置请求传递数据的格式 x-www-form-urlencoded
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    // 请求发起会经过这里
    // config：本次请求的请求配置对象
    const token = store.getters.getToken;
    if (token && config.url != "webapi/login") {
      if (config.method == "get" && !config.params.token) {
        config.params
          ? (config.params.token = token)
          : (config.params = { token: token });
      } else if (config.method == "post" && !config.data.token) {
        config.data.token = token;
      }
    }

    // 注意：这里务必要返回 config 配置对象，否则请求就停在这里出不去了
    return config;
  },
  function (error) {
    // 如果请求出错了（还没有发出去）会进入这里
    return Promise.reject(error);
  }
);

// 添加响应拦截器
request.interceptors.response.use(
  function (response) {
    let data = response.data;
    if (data.code == 1017 || data.code == 1016) {
      ElMessage({
        message: data.msg,
        grouping: true,
        type: "error",
      });
      store.commit("setUser", { token: "" });
      router.replace({ path: "/login", query: { loginAuto: true } });
    } else if (data.code == 1064) {
      store.commit("setUser", { loginkey: "" });
      router.replace({ path: "/login" });
    } else if (!data || (typeof data == "object" && data.code != 0)) {
      let error =
        response.request.responseURL +
        "\n接口报错：" +
        (data ? data.msg : "接口数据为空");
      ElMessage({
        message: error,
        grouping: true,
        type: "error",
      });
      console.log(error);
      return Promise.reject(response.data);
    }
    // 对响应数据做点什么
    return response;
  },
  function (error) {
    let errorStr = response.request.responseURL + "\n接口报错：" + error;
    ElMessage({
      message: errorStr,
      grouping: true,
      type: "error",
    });
    console.log(error);
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default request;
